import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="second-title">About us</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus
        reiciendis maiores voluptate, dolorem distinctio iste asperiores
        consequatur voluptatibus velit delectus nobis minus tempora nemo totam
        autem, aut aspernatur veniam qui ratione, adipisci iure commodi natus
        sint. Voluptas aliquid, perspiciatis reprehenderit quasi ad culpa iste
        molestias cupiditate, sunt blanditiis, praesentium eaque?
      </p>
    </section>
  );
};

export default About;
